import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, IconButton, InputAdornment, TextField, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as Helpers from 'app/Core/Helpers';
import EmpresaContaApp from 'app/ERP/EmpresaConta/EmpresaContaApp';
import * as AppActions from 'app/store/actions';
import MobileDetect from 'mobile-detect';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from '../Store/Actions/EmpresaFinanceiroActions';
import React from 'react';
import EmpresaCentroCustoApp from "app/ERP/EmpresaCentroCusto/EmpresaCentroCustoApp";
import EmpresaCategoriaApp from "app/ERP/EmpresaCategoria/EmpresaCategoriaApp";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

const NewState = {
    idtarefaprocessoapontamentoitem: null,
    idtarefaprocessoapontamentoitemgrupo: null,
    idpessoaformularioconta: null,
    idpessoaformulariocontadescricao: null,
    idpessoaformulariocategoria: null,
    idpessoaformulariocategoriadescricao: null,
    idpessoaformulariocentrocusto: null,
    idpessoaformulariocentrocustodescricao: null,
    baixa: Helpers.GetDataAtual(null, "usa"),
    valorliquido: null,
    observacao: null,
    selecteds: null,
};

class EmpresaFinanceiroBaixaDialog extends XAPPComponent {

    state = { ...NewState };

    componentDidUpdate(prevProps) {

        if (this.props.EmpresaFinanceiro.error) {
            this.props.showMessage({
                message: this.props.EmpresaFinanceiro.error,
                variant: 'error'
            });
            this.props.EmpresaFinanceiro.error = null;
        }

        if (prevProps.open === null && this.props.open !== null) {
            var obj = { ...this.props.open };
            obj.baixa = Helpers.GetDataAtual(null, "usa");
            obj.valorliquido = this.props.open.valor - this.props.open.taxas;
            this.setState(obj);
        }

        if (prevProps.open !== null && this.props.open === null) {
            this.setState(NewState);
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    canBeSubmitted = () => {
        const { baixa, valorliquido, status, observacao, idpessoaformularioconta } = this.state;

        if (status === "baixado") {
            return (
                observacao !== null && observacao !== ""
            )
        }
        else {
            return (
                baixa !== null && baixa !== "" &&
                valorliquido !== null && valorliquido !== "" &&
                idpessoaformularioconta !== null && idpessoaformularioconta !== ""
            )
        }
    }

    handleLookupEmpresaConta = (_AValue) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            let AItem = _AValue[_AValue.length - 1];
            obj.idpessoaformularioconta = AItem.idpessoaformulario;
            obj.idpessoaformulariocontadescricao = AItem.nome;
            this.setState(obj);
        } else {
            obj.idpessoaformularioconta = null;
            obj.idpessoaformulariocontadescricao = null;
            this.setState(obj);
        }
    };

    handleLookupEmpresaCategoria = (_AValue) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            let AItem = _AValue[_AValue.length - 1];
            obj.idpessoaformulariocategoria = AItem.idpessoaformulario;
            obj.idpessoaformulariocategoriadescricao = AItem.nome;
            this.setState(obj);
        } else {
            obj.idpessoaformulariocategoria = null;
            obj.idpessoaformulariocategoriadescricao = null;
            this.setState(obj);
        }
    };

    handleLookupEmpresaCentroCusto = (_AValue) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            let AItem = _AValue[_AValue.length - 1];
            obj.idpessoaformulariocentrocusto = AItem.idpessoaformulario;
            obj.idpessoaformulariocentrocustodescricao = AItem.nome;
            this.setState(obj);
        } else {
            obj.idpessoaformulariocentrocusto = null;
            obj.idpessoaformulariocentrocustodescricao = null;
            this.setState(obj);
        }
    };

    render() {
        const { savePagarReceber, open, classes, xappRouteParams, parametros, openDialog, filter, callback } = this.props;
        const form = this.state;
        return (
            <XAPPDialog
                id="FinanceiroBaixa"
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                maxWidth="sm"
                fullScreen={md.mobile() !== null}
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {form.status !== "baixado" ? "Baixar" : "Estornar"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    {form.status !== "baixado" &&
                        <div className="">
                            <TextField
                                className="mt-16"
                                id="baixa"
                                name="baixa"
                                label="Baixa"
                                value={form.baixa}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                required
                                type="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            {_.isNull(form.idtarefaprocessoapontamentoitemgrupo) && _.isNull(form.selecteds) &&
                                <TextField
                                    className="mt-16"
                                    id="valorliquido"
                                    name="valorliquido"
                                    label="Valor liquido"
                                    value={form.valorliquido}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">R$</InputAdornment>
                                    }}
                                />
                            }
                            <EmpresaContaApp
                                className="mt-16"
                                xappRouteParams={this.props.xappRouteParams}
                                required={false}
                                isLookup={true}
                                multiSelect={false}
                                onChange={this.handleLookupEmpresaConta}
                                id="NovoConta"
                                key="NovoConta"
                                label="Conta"
                                selected={!_.isNull(form.idpessoaformularioconta) ? [{ idpessoaformulario: form.idpessoaformularioconta, nome: form.idpessoaformulariocontadescricao }] : []}
                                target="spvwempresacontalookup"
                                autoSearch={true}
                                selectFirstAuto={true}
                            />
                            <EmpresaCategoriaApp
                                className="mt-16"
                                xappRouteParams={this.props.xappRouteParams}
                                required={false}
                                isLookup={true}
                                multiSelect={false}
                                onChange={this.handleLookupEmpresaCategoria}
                                id="NovoCategoria"
                                key="NovoCategoria"
                                label="Categoria"
                                selected={!_.isNull(form.idpessoaformulariocategoria) ? [{ idpessoaformulario: form.idpessoaformulariocategoria, nome: form.idpessoaformulariocategoriadescricao }] : []}
                                filter={{
                                    AND: [
                                        { "Campo": "pessoaformulario.formulario->>''natureza''", "Operador": "=", "Valor": '2' },
                                        { "Campo": "pessoaformulario.formulario->>''tipocategoria''", "Operador": "=", "Valor": parametros.tipo === 1 ? '1' : '2' }
                                    ]
                                }}
                                target="spvwempresacategorialookup"
                            />
                            <EmpresaCentroCustoApp
                                className="mt-16"
                                xappRouteParams={this.props.xappRouteParams}
                                required={false}
                                isLookup={true}
                                multiSelect={false}
                                onChange={this.handleLookupEmpresaCentroCusto}
                                id="NovoCentroCusto"
                                key="NovoCentroCusto"
                                label="Centro de Custo"
                                selected={!_.isNull(form.idpessoaformulariocentrocusto) ? [{ idpessoaformulario: form.idpessoaformulariocentrocusto, nome: form.idpessoaformulariocentrocustodescricao }] : []}
                                target="spvwempresacentrocustolookup"
                            />
                        </div>
                    }
                    <div className="pt-8 flex">
                        <TextField
                            className="mt-12"
                            id="observacao"
                            name="observacao"
                            label="Observações"
                            value={form.observacao}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            multiline
                            required={form.status === "baixado"}
                            rows={3}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            {form.status !== "baixado" ?
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    onClick={(ev) => {
                                        savePagarReceber(form.idtarefaprocessoapontamentoitemgrupo !== null ? "BAIXARITENS" : "BAIXARITEM", form, xappRouteParams, filter);
                                        if (callback !== undefined && callback !== null) {
                                            callback();
                                        }
                                        openDialog(null);
                                    }}
                                    disabled={!this.canBeSubmitted()}
                                    variant="contained"
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={'cifrao'}
                                    label={md.mobile() === null && md.tablet() === null ? 'BAIXAR' : ''}
                                    key={"btnBaixar"}
                                />
                                :
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    onClick={(ev) => {
                                        savePagarReceber(form.idtarefaprocessoapontamentoitemgrupo !== null ? "ESTORNARBAIXAITENS" : "ESTORNARBAIXAITEM", form, xappRouteParams, filter);
                                        if (callback !== undefined && callback !== null) {
                                            callback();
                                        }
                                        openDialog(null);
                                    }}
                                    disabled={!this.canBeSubmitted()}
                                    variant="contained"
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={'return'}
                                    label={md.mobile() === null && md.tablet() === null ? 'ESTORNAR' : ''}
                                    key={"btnEstornarBaixa"}
                                />
                            }
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        savePagarReceber: Actions.savePagarReceber,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroBaixaDialog)));
